module.exports = __webpack_public_path__ + "static/media/lider.6fd50126.svg";